<template>
  <div class="split-view" :class="$store.getters.sport">
    <map-view :events="this.$store.getters.events" />
    <list-view :events="this.$store.getters.events" />

    <div id="count">
      <div class="num" :class="customCountClass">{{ $store.getters.events.length }}</div>
    </div>

    <div class="loading" v-show="loading" :class="{ 'no-gif': !meetsAreAvailable }"></div>

    <message-modal v-if="!meetsAreAvailable" message="No events available!" />

    <filter-modal v-show="this.$store.getters.showFilterModal" :options="options" />
  </div>
</template>

<script>
import * as moment from 'moment'
import { apiGetter } from '@/api'
import MapView from './Map'
import ListView from './List'
import MessageModal from './modals/MessageModal'
import FilterModal from './modals/FilterModal'

export default {
  name: 'Split',
  components: {
    MapView,
    ListView,
    FilterModal,
    MessageModal,
  },
  data () {
    return {
      loading: true,
      meetsAreAvailable: true,
      customCountClass: 'num-1',
      meets: [],
      options: {},
      params: {},
    }
  },
  methods: {
    updateResponseData(meets) {
      for (let i = 0; i < meets.length; i++) {
        meets[i] = this.convertMeetLogoUrl(meets[i])
        meets[i] = this.convertDates(meets[i])
      }
      return meets
    },
    convertMeetLogoUrl(meet) {
      if (meet.logo) {
        meet.logo = require('@/' + meet.logo)
      } else {
        // Default to USA marker
        meet.logo = '/static/usa-marker-small.png'
      }
      return meet
    },
    convertDates(meet) {
      let fmt = 'ddd, MMMM D, YYYY'
      if (meet.startDate) {
        meet.startDate = moment(meet.startDate).format(fmt)
      }
      if (meet.endDate) {
        meet.endDate = moment(meet.endDate).format(fmt)
      }
      return meet
    },
  },
  beforeCreate() {
    /* Need this in case someone goes to a sport-specific page
       directly (not from homepage) */
    if (!this.$store.getters.sport) {
      this.$store.commit('setSport', this.$route.meta.sport)
    }
    apiGetter(this.$store.getters.sport, this.params).then(response => {
      this.meets = this.updateResponseData(response.data)
      this.options = response.options

      this.$store.commit('setBaseEvents', this.meets)
      this.$store.commit('setOptions', this.options)

      if (this.meets.length) {
        this.loading = false
        this.customCountClass = `num-${this.meets.length.toString().length}`
      } else {
        this.meetsAreAvailable = false
      }
    }, function() {
      console.error('API err')
      this.loading = false
      this.meetsAreAvailable = false
    })
  },
}
</script>

<style lang="scss">
$gray: #343a40;

.split-view {
  display: flex;
  flex-direction: column;
  .map-view {
    flex: 2;
  }
  .list-view {
    flex: 1;
  }
  .map-view, .list-view {
    &.full-screen {
      flex: 1 100%;
    }
  }
  // Border radius should NOT be applied to weightlifting
  &.diving img.logo {
    border-radius: 50%;
  }
  #count {
    position: absolute;
    z-index: 999;
    top: 0;
    right: 0;
    opacity: 0.75;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      border-color: transparent;
      border-style: solid;
    }
    &::before {
      border-width: 2rem;
      border-right-color: $gray;
      border-top-color: $gray;
    }
    & > .num {
      position: relative;
      color: #fff;
      padding: 0.125rem 0rem 0.5rem 1rem;
      font-size: 1.25rem;
      /* Counter should be formatted properly
         depending on length of value. */
      &.num-1 {
        padding-right: 0.75rem;
      }
      &.num-2 {
        padding-right: 0.5rem;
      }
      &.num-3 {
        padding-right: 0.25rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Split.vue